import CommonUiModel from "../common/commonUiModel";

const Detergent = new CommonUiModel({
    title: "Detergent",
    columns: [
        { field: 'DetergentId', gridLabel: 'Detergent Id', type: 'number', width: 100, label: null },
        { field: 'DetergentName', label: 'Detergent Name', required: true, max: 100 },
        { field: 'Description', label: 'Description', multiline: true, max: 2000 },
        { field: 'Notes', label: 'Notes', multiline: true, max: 2000 },
        { field: "DetergentRegion", label: "Region", lookup: 'Region', type: "autocomplete", sortable: false, required: false }
    ]
});

export default Detergent;